/**
 * Return the JSON syntax error message for a visitor segment payload, or `undefined` when valid.
 */
export function getVisitorSegmentClaimsValidationError(claims: string): string | undefined {
    try {
        JSON.parse(claims);
        return undefined;
    } catch (error) {
        return `${error instanceof SyntaxError ? error.message : error}`;
    }
}

/**
 * Parse a visitor segment payload after validating its JSON syntax.
 */
export function parseVisitorSegmentClaims(claims: string): unknown {
    const validationError = getVisitorSegmentClaimsValidationError(claims);

    if (validationError) {
        throw new SyntaxError(validationError);
    }

    return JSON.parse(claims);
}
